import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { environment } from '../../../environments/env';
import { SppdashboardService } from '../../view/dashboard/sppdashboard.service';
import { Router } from '@angular/router';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser'; // Import DomSanitizer


@Component({
  selector: 'app-user-data-modal',
  templateUrl: './user-data-modal.component.html',
  standalone: false,
  styleUrl: './user-data-modal.component.scss'
})
export class UserDataModalComponent implements OnInit {

  isNextButtonVisible: boolean = false;
  isPayButtonVisible: boolean = false;

  constructor(private sanitizer: DomSanitizer, private router: Router, private sppdashboardService: SppdashboardService, public dialogRef: MatDialogRef<UserDataModalComponent>, @Inject(MAT_DIALOG_DATA) public data: any) {
    dialogRef.disableClose = true;
  }

  safeHtmlContent!: SafeHtml; // To hold the sanitized message
  dynamicFormFields: any = this.data.value;
  headerTitle: any = this.data.value?.headerTitle;

  modalTitle: any = 'Training Outcome';
  date: any;

  currentDate: any;
  timelinedate: any;
  rtimelinedate: any;
  timeline: any
  rtimeline: any;

  ngOnInit() {

    if (this.dynamicFormFields?.data?.status == 'RENEWAL_REJECT' || this.dynamicFormFields?.data?.status == 'TEST_OUT_FAIL' || 
        this.dynamicFormFields?.data?.status == 'FIRST_LOGIN' || this.dynamicFormFields?.data?.status == 'OPEN') {
      this.isNextButtonVisible = true;
    }

    if (this.dynamicFormFields?.data?.status == 'TEST_OUT_OPEN' && sessionStorage.getItem('endDate') === "null") {
      this.isPayButtonVisible = true;
    }

    if (this.dynamicFormFields?.userSelectedFlow === 'ISCPFlow') {
      this.isNextButtonVisible = false; // Hide the Next button for ISCPFlow
    }

    this.modalTitle = this.dynamicFormFields.title ? this.dynamicFormFields.title : 'User Status';
    // Sanitize the message for HTML rendering (only for EXPIRED case)
    if (this.dynamicFormFields?.message) {
      this.safeHtmlContent = this.sanitizer.bypassSecurityTrustHtml(this.dynamicFormFields.message);
    } else {
      // Fallback for other cases (e.g., plain text or JSON string)
      this.safeHtmlContent = this.sanitizer.bypassSecurityTrustHtml(JSON.stringify(this.dynamicFormFields));
    }
    this.date = new Date(this.dynamicFormFields?.data?.mctSubscriptionStartDate ? this.dynamicFormFields?.data?.mctSubscriptionStartDate : new Date());

    this.sppdashboardService.gettimeline().subscribe((resp: any) => {

      this.timeline = resp.data.content[0].mctTimeline;
      this.date.setDate(this.date.getDate() + this.timeline);
      this.timelinedate = new Date(this.date);

      this.currentDate = new Date();
      this.rtimeline = resp.data.content[0].reminderTimeline;

      this.timelinedate.setDate(this.timelinedate.getDate() - this.rtimeline);
      this.rtimelinedate = new Date(this.timelinedate);
    })
  }

  openHelpRequestForm = () => {
    sessionStorage.setItem('fromDashboard', 'true');
    this.router.navigate(['/support']);
  }

  close(): void {

    // Reinstate to test out open expected to home page 
    if (this.dynamicFormFields?.data?.status == 'RENEWAL' || this.dynamicFormFields?.data?.status == 'ACTIVE_MCT' || 
        this.dynamicFormFields?.data?.status == 'RENEWAL_APPROVE' || this.dynamicFormFields?.data?.status == 'TEST_OUT_OPEN') {
        this.router.navigate(['/home']);
        this.dialogRef.close();
    } else if (this.dynamicFormFields?.data?.status == 'SUSPEND' || this.dynamicFormFields?.data?.status == 'FIRST_LOGIN' || 
        this.dynamicFormFields?.data?.status == 'OPEN' || this.dynamicFormFields?.data?.status == 'ILT_FAIL' || 
        this.dynamicFormFields?.data?.status == 'EXPIRED' || this.dynamicFormFields?.data?.status == 'ALUMNI' || 
        this.dynamicFormFields?.data?.status == 'REINSTATE_SUBMIT') {
        window.open(environment.BASE_URL + "/ptp/security/ssoLogout?entryPoint=" + environment.APP_URL + "/#/prelogin", '_self');
         this.dialogRef.close();
    }
    else {
      this.dialogRef.close();
    }
  }

  next(): void {
  if (this.dynamicFormFields?.data?.status == 'TEST_OUT_OPEN'){
      this.router.navigate(['/home']);
      this.dialogRef.close();
    } else if (this.dynamicFormFields?.data?.status == 'OPEN' || this.dynamicFormFields?.data?.status == 'FIRST_LOGIN' || 
                this.dynamicFormFields?.data?.status == 'TEST_OUT_FAIL') {
      this.dialogRef.close('trainingSelection');
    } else if (this.dynamicFormFields?.data?.status == 'RENEWAL_REJECT') {
      this.dialogRef.close();
    } else {
      this.router.navigate(['/home']);
      this.dialogRef.close();
    }
  }

  onClickPaynow(): void {
    this.router.navigate(['/live']);
    this.dialogRef.close();
  }
}
